import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import toast from 'react-hot-toast';
import { getNotificationHistory, getUsers } from '../data/mockData';
import NotificationHistory from '../components/notifications/NotificationHistory';
import NotificationComposer from '../components/notifications/NotificationComposer';
import ConfirmationDialog from '../components/shared/ConfirmationDialog';
import api from '../services/ApiService';
import { ENDPOINTS } from '../constant/ApiEndpoints';
import useDidFetch from '../custom_hooks/useDidfetch';

const NotificationsPage = () => {
    const [history, setHistory] = useState([]);
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    const [notificationToSend, setNotificationToSend] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleSendOrSchedule = (notificationData) => {
        setNotificationToSend(notificationData); 
        console.log(notificationData);
        setIsConfirmOpen(true) 
        // notificationData?.targetGroup == 'all' ?
        //     setIsConfirmOpen(true) : confirmSend()
    };
    const runOnce = useDidFetch();
    useEffect(() => {
        runOnce(() => {
            // setHistory(getNotificationHistory())
            getNotifyHistory()
        })
    }, [])

    const getNotifyHistory = async () => {
        try {
            let response = await api.get(ENDPOINTS.getNotificationApi);
            let result = response?.data ?? [];
            if (response?.status == 200 || response?.status == 201) {
                setHistory(result);
            }

        } catch (error) {
            console.log("getNotifyHistory error", error);
        }
    }

    const confirmSend = async () => {
const userId = parseInt(notificationToSend?.specificUser, 10) || 0;

        let notifData = {
            "target": notificationToSend?.targetGroup,
            "user_id": userId,
            "title": notificationToSend?.title,
            "message": notificationToSend?.message,
            "platform": notificationToSend?.channels,
        }
        console.log("notificationData", notifData);

        try {
            setIsLoading(true);
            let response = await api.post(ENDPOINTS.notificationApi, notifData);
            let result = response.data;
            if (response?.status == 200 || response?.status == 201) {
                toast.success(`Notification has been sent.`);
                setIsConfirmOpen(false);
                setNotificationToSend(null);
            }
        } catch (error) {
            console.log("handleSend notification", error);
        } finally {
            setIsLoading(false)
        }
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="space-y-6"
        >
            <h1 className="text-3xl font-bold font-display text-gray-800">Notifications</h1>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div className="lg:col-span-2">
                    <NotificationComposer onSend={handleSendOrSchedule} />
                </div>
                <div className="lg:col-span-1">
                    <NotificationHistory notifications={history} />
                </div>
            </div>

            <ConfirmationDialog
                isOpen={isConfirmOpen}
                onClose={() => setIsConfirmOpen(false)}
                onConfirm={confirmSend}
                title={`Confirm ${notificationToSend?.scheduleTime ? 'Scheduling' : 'Send'}`}
                description={`Are you sure you want to ${notificationToSend?.scheduleTime ? 'schedule' : 'send'} this notification to "${notificationToSend?.targetGroup}"?`}
            />
        </motion.div>
    );
};

export default NotificationsPage;
